import type { TReplacer } from './models';

/**
 * Матчер для определения выражений в шаблонной строке
 *
 * @example 'Hello {title}. {name}!' => ['{title}', '{name}']
 */
const TEMPLATE_EXPRESSION_MATCHER = /{[^\d{]\S+?}/g;

/**
 * Реплейсер для получения аргумента из выражения
 *
 * @example '{user.name}' => 'user.name'
 */
const EXPRESSION_REPLACER = /^{|}$/g;

/**
 * Создать функцию которая применит значения к выражениям шаблона
 * @param replace Функция принимает аргумент выражения и возвращает значение на которое выражение будет заменено
 * @returns Функция которая принимает шаблон `template` и возвращает строку с примененными значениями вместо выражений
 *
 * @remarks
 * `'Hello {user.name}!'` - шаблон
 *
 * `'{user.name}'` - выражение шаблона
 *
 * `'user.name'` - аргумент выражения
 */
export const createTemplater = (replace: TReplacer) => (template: string) => {
    const expressions = template.match(TEMPLATE_EXPRESSION_MATCHER);
    if (!expressions) return template;

    return expressions.reduce((result, expression) => {
        const arg = expression.replace(EXPRESSION_REPLACER, '');
        try {
            return result.replace(expression, replace(arg));
        } catch (e) {
            console.error(e);

            return result;
        }
    }, template);
};
